var Papa = require("papaparse");

// Thanks @ Glen Thompson
// https://stackoverflow.com/questions/14964035/how-to-export-javascript-array-info-to-csv-on-client-side

// Data should be an array of objects (or maybe array of arrays)
export function downloadCSV(data, columns, filename) {
	var filename = filename || "wr-export.csv";
	let csv = Papa.unparse({ data: data, fields: columns})
	if (!csv) { return; }

	var blob = new Blob([csv]);
	if (window.navigator.msSaveOrOpenBlob) {
		// IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
		window.navigator.msSaveBlob(blob, filename);
	} else {
		var a = window.document.createElement("a");
		a.href = window.URL.createObjectURL(blob, { type: "text/plain" });
		a.download = filename;
		document.body.appendChild(a);
		a.click();  // IE: "Access is denied"; see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
		document.body.removeChild(a);
	}
}


// WEBPACK FOOTER //
// ./modules/lib/data/DownloadData.js